module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoBlkOl.6f3755e9.otf";